/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  accessAPI,
  Boton,
  Titulo,
  CampoInformacion,
  Formulario, tituloBase } from "../../../shared";

import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import { Sidebar } from "../../../shared";

export default function AuditorTipoDetalle() {
  const [auditorTipo, setAuditorTipo] = useState(null);
  const [sidebarEditar, setSidebarEditar] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);
  const { auditorTipoId } = useParams();
  const toast = useRef(null);

  useEffect(() => {
    cargarAuditorTipo();
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function cargarAuditorTipo() {
    accessAPI(
      "GET",
      `admin/auditor/auditortipo/${auditorTipoId}`,
      null,
      (respuesta) => {
        setAuditorTipo(respuesta);
        document.title = respuesta.nombre;
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al cargar el tipo de colaborador",
          sticky: true
        });
      }
    );
  }

  function editarAuditorTipoSubmit(respuestasFormulario) {
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/auditor/auditortipo/${auditorTipoId}`,
      respuestasFormulario,
      (respuesta) => {
        setAuditorTipo((prev) => ({ ...prev, ...respuesta }));
        document.title = respuesta.nombre;
        setSidebarEditar(false);
        setLoaderEditar(false);
        toast.current?.show({
          severity: "success",
          summary: "Actualizado",
          detail: "Tipo de colaborador actualizado exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Error al actualizar el tipo de colaborador",
          sticky: true
        });
        setLoaderEditar(false);
      }
    );
  }

  const editarFormConfig = auditorTipo
    ? {
        secciones: [
          {
            campos: [
              {
                nombre: "nombre",
                tipoitemformularioid: 1,
                etiqueta: "Nombre",
                requerido: true,
                respuesta: auditorTipo.nombre
              },
              {
                nombre: "esRevisorSolicitud",
                tipoitemformularioid: 6,
                etiqueta: "Revisor de solicitudes",
                respuesta: auditorTipo.esRevisorSolicitud
              }
            ]
          }
        ],
        botones: [
          {
            etiqueta: "Guardar cambios",
            callback: editarAuditorTipoSubmit,
            validar: true
          }
        ]
      }
    : null;

  return (
    <>
      <Toast ref={toast} position="top-center" />

      {!auditorTipo && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "1em"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div css={{ display: "flex", alignItems: "center", gap: "1em" }}>
              <Skeleton width="2rem" height="2rem" shape="circle" />
              <Skeleton width="15rem" height="2rem" />
            </div>
          </div>
          <Card>
            <Skeleton
              width="6rem"
              height="1.5rem"
              css={{ marginBottom: "1.5em" }}
            />
            <div className="grid">
              {[...Array(2)].map((_, i) => (
                <div key={i} className="col-12 md:col-6">
                  <Skeleton
                    width="50%"
                    height="0.8rem"
                    css={{ marginBottom: "0.5rem" }}
                  />
                  <Skeleton width="80%" height="1.2rem" />
                </div>
              ))}
            </div>
          </Card>
        </div>
      )}

      {auditorTipo && (
        <>
          <Titulo urlVolver="/proveedores/auditortipos">
            {auditorTipo.nombre}
          </Titulo>

          <Card>
            <Titulo
              botones={
                <Boton icono negro callback={() => setSidebarEditar(true)}>
                  <i className="pi pi-pencil" />
                </Boton>
              }
            >
              Detalles
            </Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="Nombre">
                {auditorTipo.nombre}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Revisor de solicitudes">
                {auditorTipo.esRevisorSolicitud ? "Sí" : "No"}
              </CampoInformacion>
            </div>
          </Card>

          <Sidebar
            visible={sidebarEditar}
            position="right"
            onHide={() => setSidebarEditar(false)}
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>Editar tipo de colaborador</Titulo>
            {editarFormConfig && (
              <Formulario
                key={auditorTipo.id + "-" + auditorTipo.nombre}
                config={editarFormConfig}
                loader={loaderEditar}
              />
            )}
          </Sidebar>
        </>
      )}
    </>
  );
}
